import { createContext } from 'react';

export const TextToSpeechModifiersContext = createContext({});

export default TextToSpeechModifiersContext;
